import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { makeAjax, respStatus, showMessage, url } from "../../helpers/global_helper";
import { TOKEN_KEY } from "../../helpers/url_helper";
import { getUserProfile, setCommonConfig } from "../../redux/actions";
import { useDispatch } from "react-redux";
import { useVisitorData } from '@fingerprintjs/fingerprintjs-pro-react';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { ClientJS } from 'clientjs';
import { getClientJSData } from "../../helpers/clientInfo";


const LaunchLobby = (props) => {

  const fptoolkit = process.env.REACT_APP_FPTOOLKIT || "free";
  const hasRuncd = useRef(false);
  const [fpHash, setFpHash] = useState(null);
  const [clientJsFingerPrint, setClientJsFingerPrint] = useState(null);
  const client = new ClientJS();

  const generateClientJSFingerprint = () => {
    try {
      const clientfingerprint = client.getFingerprint();
      localStorage.setItem('clientJsFingerPrint', clientfingerprint);
      setClientJsFingerPrint(clientfingerprint);
    } catch (error) {
      console.error('[LaunchLobby] Failed to generate clientJS_FP:', error);
    }
  };

  const getHash = (fingerprint, clientjs) => {
    const encoder = new TextEncoder();
    const data = encoder.encode(fingerprint + clientjs);
    return crypto.subtle.digest('SHA-256', data).then(hashBuffer => {
      const hashArray = Array.from(new Uint8Array(hashBuffer));
      const hash = hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('');
      return hash;
    });
  };


  useEffect(() => {
    const setFp = async () => {
      const fp = await FingerprintJS.load();
      const { visitorId } = await fp.get();
      setFpHash({ "visitorId": visitorId });
    };
    setFp();
    generateClientJSFingerprint();
  }, []);

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  let depositUrl = params.get("depositurl");
  if (depositUrl) {
    try {
      const href = window.location.href || '';
      const m = href.match(/[?&]depositurl=(.*)$/);

      if (m && m[1]) {
        try {
          depositUrl = decodeURIComponent(m[1]);
        } catch (e) {
          depositUrl = m[1];
        }
      }
    } catch (e) {
      console.warn('Could not reconstruct depositUrl from href', e);
    }
    const newUrl = `${depositUrl}&gt=togel`;
    sessionStorage.setItem("depositUrl", newUrl);
  }


  const dispatch = useDispatch();
  let storedFPJS = localStorage.getItem('fpjs');
  const [imageLoader, setImageLoader] = useState(null);
  const [partner, setPartner] = useState(null);
  const { token, operatorid, username, channel, game_id } = useParams();
  const navigate = useNavigate();
  localStorage.setItem('activeGameId', game_id);

  const [fpjs, setFPJS] = useState({
    requestId: "",
    visitorId: "",
    deviceBrowser: "",
  });

  const [userId, setUserId] = useState('');
  const [userName, setUserName] = useState('');

  useEffect(() => {
    if (imageLoader) {
      localStorage.setItem('loader', imageLoader);
      props.setLoader(imageLoader);
      props.setPartnerKey(partner);
    }
  }, [imageLoader]);
  const checkDevice = async () => {
    try {
      let clientjs = localStorage.getItem('clientJsFingerPrint');
      if (!clientjs) {
        await generateClientJSFingerprint();
        clientjs = localStorage.getItem('clientJsFingerPrint');
      }
      if (!storedFPJS || !clientjs) {
        console.warn('Missing required data: storedFPJS or clientjs');
        return;
      }

      const fp = JSON.parse(storedFPJS);
      const fingerprint = fp.visitorId;

      const clientData = await getClientJSData(client);
      const hashedFingerprint = await getHash(fingerprint, clientjs);
      const deviceBrowser = `${clientData.getBrowser} ${clientData.getOS}`;
      const reqData = { visitorId: hashedFingerprint, clientData: clientData, deviceBrowser: deviceBrowser, userName:  username};

      const response = await makeAjax(url.PLAYER_API.checkDevice, reqData, url.PLAYER_MS_EXT);
      if (response.status === respStatus['SUCCESS']) {
        hasRuncd.current = true;
      } else if (response.status === respStatus['ERROR']) {
        console.error('Error in checkDevice:', response);
      }
    }
    catch (error) {
      console.error('Error in checkDevice:', error);
    };
  };

  const getMyToken = async (event) => {
    try {
      let reqData = {
        token: token,
        operatorid: operatorid,
        user_name: username,
        channel: channel
      };

      localStorage.clear();
      // if (
      //   localStorage.getItem("partner_token")
      //   && localStorage.getItem("partner_token") == token
      //   && username == localStorage.getItem('partner_username')
      //   && localStorage.getItem(url.TOKEN_KEY)
      // ) {
      //   const balanceResp = await makeAjax(url.PLAYER_API.verifyLogin, {}, url.PLAYER_MS_EXT);
      //   if (balanceResp && balanceResp.status == respStatus['SUCCESS']) {
      //     dispatch(setCommonConfig({ key: 'promoStatus', value: 1 }))
      //     navigate('/');
      //     return;
      //   }
      // }

      const response = await makeAjax(url.PLAYER_API.addUserSession, reqData, url.PLAYER_MS_EXT);
      if (response.status !== respStatus['SUCCESS']) {
        if (response.code === "lobby_maintenance" || response.code === "inactive_partner") {
          navigate('/maintenance');
          return
        }

        showMessage(response);
        return;
      }
      await
        fetchData(response.data.loaderJS, response.data.partner);
      localStorage.setItem(TOKEN_KEY, response.data.token);
      localStorage.setItem("partner", response.data.partner);
      localStorage.setItem('partner_token', token);
      const updatedUserName = response.data.userName;
      setUserName(updatedUserName);
      localStorage.setItem('user_name', updatedUserName);
      localStorage.setItem('partner_username', username);
      localStorage.setItem("partnerYear", response.data.partnerYear);
      localStorage.setItem("partnerFlag", response.data.partnerFlag);
      localStorage.setItem("refBtnVal", 0);
      const updatedUserId = response.data.userId;
      setUserId(updatedUserId);
      dispatch(setCommonConfig({ key: 'promoStatus', value: 1 }))
      dispatch(getUserProfile());
      if (response.data.userBlocked === true) {
        navigate('/blockUser');
        return
      }
      setTimeout(function () {
        navigate('/');
      }, 1000);
    } catch (err) {
      console.error("getMyToken error", err);
      showMessage({ message: "Something went wrong", type: "error" });
    }
  }

  const fetchData = async (url, partnerKey = null) => {
    const response = await fetch(url);
    const data = await response.text();
    //Loader Image
    const base64Regex1 = /loading_lobby\s*=\s*"([^"]*)"/;
    const match1 = data.match(base64Regex1);
    if (match1 && match1.length > 1) {
      setImageLoader(match1[1]);
      setPartner(partnerKey);
    } else {
      console.error('404 Loader Image');
    }
    //Logo Image
    const base64Regex2 = /logo\s*=\s*"([^"]*)"/;
    const match2 = data.match(base64Regex2);
  }

  const { isLoading, error, data, getData } = useVisitorData(
    { extendedResult: true },
    { immediate: false }
  );


  useEffect(() => {
    if (!data) return;
    const { requestId, visitorId, browserName, os, osVersion } = data;
    const concatenatedValue = `${browserName || ""} ${os || ""} ${osVersion || ""}`;
    setFPJS({
      requestId: requestId || "",
      visitorId: visitorId || "",
      deviceBrowser: concatenatedValue.trim(),
    });
  }, [data]);

  useEffect(() => {
    if (fptoolkit == "paid") {
      if (fpjs.requestId) {
        localStorage.setItem("fpjs", JSON.stringify(fpjs));
        storedFPJS = localStorage.getItem('fpjs');
        setTimeout(() => {
          checkDevice();
        }, 7000);
      }
    }
  }, [fpjs]);

  useEffect(() => {
    if (!hasRuncd.current && fpHash && userId && userName) {
      localStorage.setItem("fpjs", JSON.stringify(fpHash));
      storedFPJS = localStorage.getItem('fpjs');
      setTimeout(() => {
        hasRuncd.current = true;
        checkDevice();
      }, 7000);
    }
  }, [fpHash, userId, userName]);

  useEffect(() => {
    getMyToken();
    if (!hasRuncd.current && storedFPJS) {
      hasRuncd.current = true;
      setTimeout(() => {
        checkDevice();
      }, 7000);
    }
  }, [token, operatorid, username, channel]);

  useEffect(() => {
    if (fptoolkit == "paid") {
      if (!storedFPJS) {
        if (userId && userName) {
          console.debug("Triggering getData...");
          getData({
            linkedId: userId,
            tag: {
              env: "199",
              username: userName,
            }
          });
        }
      }
    }
  }, [userId, username]);

  return (
    <>
      <div>Loading...</div>
    </>
  );
}
export default LaunchLobby;
